// Dynamic Diesels — Community band stat count-up.
// When the section enters the viewport, animate each stat from 0 → target,
// preserving a suffix like "+" and comma formatting. Respects
// prefers-reduced-motion by skipping the animation entirely.

(function () {
  'use strict';

  const DURATION_MS = 1200;

  function init() {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.dd-community').forEach((section) => {
      const stats = section.querySelectorAll('.dd-community__stat-num[data-count-to]');
      if (!stats.length) return;

      if (reduce || !('IntersectionObserver' in window)) {
        // Non-animated: leave rendered values as-is.
        return;
      }

      const io = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            stats.forEach(runCountUp);
            observer.disconnect();
          });
        },
        { threshold: 0.35 }
      );
      io.observe(section);
    });
  }

  function runCountUp(el) {
    const target = parseFloat(el.getAttribute('data-count-to'));
    const suffix = el.getAttribute('data-suffix') || '';
    if (!isFinite(target)) return;

    const start = performance.now();
    function tick(now) {
      const elapsed = now - start;
      const t = Math.min(elapsed / DURATION_MS, 1);
      const eased = 1 - Math.pow(1 - t, 3); // ease-out cubic
      const current = Math.round(target * eased);
      el.textContent = current.toLocaleString() + suffix;
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
